

















































import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import { rules } from "../services/validation";
import * as types from "../store/types";

export default Vue.extend({
  name: "RequestPasswordResetPage",

  metaInfo() {
    return {
      title: "Request Password Reset | ARPA Small Business - Greene County, MO",
    };
  },

  data() {
    return {
      valid: true,
      requestSuccess: false,
      email: "",
      rules,
    };
  },

  methods: {
    ...mapActions({
      submit: types.REQUEST_PASSWORD_RESET,
    }),
    async validate() {
      // @ts-ignore
      if (this.$refs.loginForm && this.$refs.loginForm.validate()) {
        this.submit({
          email: this.email,
        }).then(() => {
          setTimeout(() => {
            if (!this.requestErrorMessage) this.requestSuccess = true;
          }, 100);
        });
      }
    },
  },

  computed: {
    ...mapGetters({
      isSubmitting: types.REQUESTING_RESET,
      requestErrorMessage: types.RESET_REQUEST_ERROR,
    }),
  },
});
